import React, { useContext } from 'react'
import { BodyContext } from '../../../contexts/BodyProvider'
import './searchBI.css'

type Props = {
  titlePlaceholder: string
}

const SearchBI = ({titlePlaceholder}: Props) => {
  const {searchValues} = useContext(BodyContext);

  return (
    <div className='search_items_bi'>
        <input
            type="text"
            value={searchValues?.search}
            onChange={(e) => searchValues?.setSearch(e.target.value)}
            placeholder={titlePlaceholder}/>
        <i className="bi bi-search" style={{fontSize: "22px"}}></i>
    </div>
  )
}

export default SearchBI